eshopApp.factory('alertMessage', ['$timeout' ,function($timeout){

	var typeClasses = {
		error : 'alert-danger',
		success : 'alert-success',
		info : 'alert-info',
		warning : 'alert-warning'
	};

	var messages = [];
	var alertMessage = {};

	alertMessage.set = function(msg, type, timeout) {
		
		// Push msg to array and return index
		messages.push({ msg: msg, type: type });

		// Set timeout
		if (timeout !== false) {
			if (typeof timeout === 'undefined') {
				// Default timeout, 3 seconds
				$timeout(function(){ messages.splice(0, 1); }, 3000);

			} else {
				// Custom timeout
				$timeout(function(){ messages.splice(0, 1); }, timeout);
			}
		}

	};

	alertMessage.getType = function(alert) {
		return typeClasses[alert.type];
	}

	alertMessage.getMessages = function() {
		return messages;
	};

	alertMessage.deleteMessage = function(index) {
		messages.splice(index, 1);
	};
	
	return alertMessage;
}]);